import React from 'react';
import { motion } from 'framer-motion';

const FeaturesSection = () => {
  const features = [
    {
      icon: '/assets/icons/live-tracking.svg',
      title: 'Find Service Providers Near You',
      description: 'Discover trusted professionals in your area for all your needs, anytime you need them.'
    },
    {
      icon: '/assets/icons/insurance.svg',
      title: 'Seamless Transactions, Start to Finish',
      description: 'Handle everything within the app from booking to payment; quick, secure, and hassle free.'
    },
    {
      icon: '/assets/icons/quality-control.svg',
      title: 'Quality Control',
      description: 'Our drivers are thoroughly vetted to ensure a quality ride.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <motion.h2 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-3xl font-bold text-center text-black mb-4"
        >
          Your Trusted Partner for Seamless
        </motion.h2>
        <motion.h3
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="text-3xl font-bold text-center text-black mb-16"
        >
          On Demand Services
        </motion.h3>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={feature.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              className="bg-white rounded-lg p-8 text-center shadow-md relative border border-gray-200"
            >
              <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-black rounded-full w-20 h-20 flex items-center justify-center border border-gray-200">
                <img src={feature.icon} alt={feature.title} className="w-10 h-10" />
              </div>
              <h3 className="text-xl font-bold text-black mt-8 mb-4">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;